module.exports = __webpack_public_path__ + "static/map_cube.aa4e94df.jpg";